import React, { useState } from "react";
import CardWrap from "../Common/CardWrap";
import { useTranslation } from "react-i18next";

// Dane i opcije
const dayOptions = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
  { value: 8, label: "Holiday" },
];

const typeOptions = ["Redovno", "Iznimke"];
const optionOptions = ["Jednokratno", "Dvokratno", "ParNepar"];

// --- WorkingHoursForm komponenta ---
function WorkingHoursForm({ hours, setHours }) {
  const addRow = () => {
    setHours([
      ...hours,
      { DayOfWeek: "", Start: "", End: "", Type: "", Options: "", Note: "" },
    ]);
  };

  const removeRow = (index) => {
    setHours(hours.filter((_, i) => i !== index));
  };

  const updateRow = (index, field, value) => {
    const newHours = [...hours];
    newHours[index][field] = value;
    setHours(newHours);
  };

  const getDisabledDays = (currentIndex) => {
    const currentType = hours[currentIndex]?.Type;
    return hours
      .filter((_, i) => i !== currentIndex && hours[i].Type === currentType)
      .map((h) => h.DayOfWeek);
  };

  const applyToAllDays = (index) => {
    const current = hours[index];
    if (!current.Type || !current.Start || !current.End) {
      alert("Please fill Type and Times before applying to all days");
      return;
    }

    const usedDays = hours
      .filter((h) => h.Type === current.Type)
      .map((h) => h.DayOfWeek);

    const newRows = dayOptions
      .filter((d) => !usedDays.includes(d.value))
      .map((d) => ({
        DayOfWeek: d.value,
        Start: current.Start,
        End: current.End,
        Type: current.Type,
        Options: current.Options,
        Note: current.Note,
      }));

    setHours([...hours, ...newRows]);
  };

  return (
    <div className="space-y-4">
      {hours.map((row, index) => {
        const disabledDays = getDisabledDays(index);
        return (
          <div
            key={index}
            className="border p-4 rounded flex flex-col md:flex-row md:space-x-4 space-y-2 md:space-y-0 items-center"
          >
            <select
              value={row.DayOfWeek}
              onChange={(e) => updateRow(index, "DayOfWeek", Number(e.target.value))}
              required
              className="form-control"
            >
              <option value="">Select Day</option>
              {dayOptions.map((d) => (
                <option
                  key={d.value}
                  value={d.value}
                  disabled={disabledDays.includes(d.value)}
                >
                  {d.label}
                </option>
              ))}
            </select>

            <input
              type="time"
              value={row.Start}
              onChange={(e) => updateRow(index, "Start", e.target.value)}
              required
              className="form-control"
            />

            <input
              type="time"
              value={row.End}
              onChange={(e) => updateRow(index, "End", e.target.value)}
              required
              className="form-control"
            />

            <select
              value={row.Type}
              onChange={(e) => updateRow(index, "Type", e.target.value)}
              required
              className="form-control"
            >
              <option value="">Select Type</option>
              {typeOptions.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>

            <select
              value={row.Options}
              onChange={(e) => updateRow(index, "Options", e.target.value)}
              required
               className="form-control"
            >
              <option value="">Select Option</option>
              {optionOptions.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Note"
              value={row.Note}
              onChange={(e) => updateRow(index, "Note", e.target.value)}
              className="form-control"
            />

            <div className="flex space-x-1">
              <button
                type="button"
                onClick={() => removeRow(index)}
                className="btn btn-primary"
              >
                Remove
              </button>
              <button
                type="button"
                onClick={() => applyToAllDays(index)}
                 className="btn btn-primary"
              >
                Apply to All Days
              </button>
            </div>
          </div>
        );
      })}

      <div className="flex space-x-2">
        <button
          type="button"
          onClick={addRow}
           className="btn btn-primary"
        >
          Add Working Hour
        </button>
      </div>
    </div>
  );
}

// --- Main CardWrap Form ---
export default function WorkingHoursCard( ) {
  const [hours, setHours] = useState([]);
  const { t: translator } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(hours);
    alert("Check console for submitted data");
  };

  const handleCancel = () => {
    setHours([]);
  };

  return (
    <CardWrap subtitle= {translator("ShiftUpdate-WorkingHours")}>
      <form onSubmit={handleSubmit} className="row">
        <div className="col-lg-12">
          <fieldset className="scheduler-border">
            

            <WorkingHoursForm hours={hours} setHours={setHours} />
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{
            display: "flex",
            paddingTop: "3%",
            justifyContent: "flex-end",
          }}
        >
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={handleCancel}
          >
            {translator("Btn-Cancel")}
          </button>

          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
    </CardWrap>
  );
}
